// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class ApiCommunityMemberOverview {
    'display': string;
    'detail_view_key': string;
    'level': number;
    'tdh': number;
    'tdh_rate': number;
    'xtdh': number;
    'xtdh_rate': number;
    'xtdh_outgoing': number;
    'xtdh_incoming': number;
    'combined_tdh': number;
    'combined_tdh_rate': number;
    'rep': number;
    'cic': number;
    'pfp': string | null;
    'last_activity': number | null;
    'wallet': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "display",
            "baseName": "display",
            "type": "string",
            "format": ""
        },
        {
            "name": "detail_view_key",
            "baseName": "detail_view_key",
            "type": "string",
            "format": ""
        },
        {
            "name": "level",
            "baseName": "level",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "tdh",
            "baseName": "tdh",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "tdh_rate",
            "baseName": "tdh_rate",
            "type": "number",
            "format": "double"
        },
        {
            "name": "xtdh",
            "baseName": "xtdh",
            "type": "number",
            "format": "double"
        },
        {
            "name": "xtdh_rate",
            "baseName": "xtdh_rate",
            "type": "number",
            "format": "double"
        },
        {
            "name": "xtdh_outgoing",
            "baseName": "xtdh_outgoing",
            "type": "number",
            "format": "double"
        },
        {
            "name": "xtdh_incoming",
            "baseName": "xtdh_incoming",
            "type": "number",
            "format": "double"
        },
        {
            "name": "combined_tdh",
            "baseName": "combined_tdh",
            "type": "number",
            "format": "double"
        },
        {
            "name": "combined_tdh_rate",
            "baseName": "combined_tdh_rate",
            "type": "number",
            "format": "double"
        },
        {
            "name": "rep",
            "baseName": "rep",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "cic",
            "baseName": "cic",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "pfp",
            "baseName": "pfp",
            "type": "string",
            "format": ""
        },
        {
            "name": "last_activity",
            "baseName": "last_activity",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "wallet",
            "baseName": "wallet",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiCommunityMemberOverview.attributeTypeMap;
    }

    public constructor() {
    }
}

